import { Navigate, useParams } from "react-router-dom";
import { PublicCycleProvider, usePublicCycle } from "@/context/PublicCycleContext";
import { PublicCycleLayout } from "@/components/layout/PublicCycleLayout";
import { PublicCycleGate } from "@/components/v2/public/PublicCycleGate";
import HomePage from "@/pages/v2/HomePage";

function PublicHomeInner() {
  const { token } = useParams<{ token: string }>();
  const { session } = usePublicCycle();

  if (!session) {
    return <Navigate to={`/join/public/${token}`} replace />;
  }

  return (
    <PublicCycleLayout>
      <HomePage />
    </PublicCycleLayout>
  );
}

export default function PublicHomePage() {
  const { token } = useParams<{ token: string }>();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return (
    <PublicCycleProvider token={token}>
      <PublicHomeInner />
    </PublicCycleProvider>
  );
}

export function PublicJoinEntry() {
  return <PublicCycleGate />;
}
